import { IDeleteFornecedorDocumentoUseCase } from "../../../presentation/useCases/delete/delete_fornecedor_documento_use_case";
import { IComprasRepository } from "../../repositories/compras_repositories";

/**
 * DeleteFornecedorDocumentoUseCase
 */

export class DeleteFornecedorDocumentoUseCase implements IDeleteFornecedorDocumentoUseCase {
  constructor(private readonly repository: IComprasRepository) { }

  async deleteFornecedorDocumento(
    idFornecedor: number,
    idFornecedorArquivo: number,
  ): Promise<void> {
    await this.repository.deleteFornecedorDocumento(
      idFornecedor,
      idFornecedorArquivo,
    );
  }
}
